<template>
    <v-footer app color="#ef6b01" rounded="0">
    </v-footer>
</template>

<script>

export default {
  name: 'Footer',

  data: () => ({
    //
  }),
};
</script>